import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=09ffc28e&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=09ffc28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ffc28e",
  null
  
)

export default component.exports